import CategoriesMenu from './categoriesMenu'

export default CategoriesMenu



// WEBPACK FOOTER //
// ./client/components/categoriesMenu/index.js